/**
 * Created by mateimisarca on 2019-06-07
 */

import Heading from './heading';
export default Heading;
